import React from "react";
import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Title from "../Layout/Title";

// Generate Order Data
function createData(id, date, name, shipTo, paymentMethod, amount) {
  return { id, date, name, shipTo, paymentMethod, amount };
}

const rows = [
  createData(
    0,
    "06 September 2023",
    "Akash Maourya",
    "Sachin, ST",
    "VISA ⠀•••• 3719",
    105.0
  ),
  createData(
    1,
    "06 September 2023",
    "Binit Singh",
    "Balia, BR",
    "VISA ⠀•••• 2574",
    215.0
  ),
  createData(
    2,
    "06 September 2023",
    "Chandan Mishra",
    "Varanshi, UP",
    "MC ⠀•••• 1253",
    100.0
  ),
  createData(
    3,
    "06 September 2023",
    "Deepak Yadav",
    "Bareily, UP",
    "AMEX ⠀•••• 2000",
    655.0
  ),
  createData(
    4,
    "06 September 2023",
    "Hitesh Kapur",
    "Mandavi, GJ",
    "VISA ⠀•••• 5919",
    199.0
  ),
];

function preventDefault(event) {
  event.preventDefault();
}

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  gridPadding: {
    padding: "15px",
  },
}));

export default function Orders() {
  const classes = useStyles();
  return (
    <div className={classes.gridPadding}>
      <Title>Recent Orders</Title>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Ship To</TableCell>
            <TableCell>Payment Method</TableCell>
            <TableCell align="right">Sale Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id}>
              <TableCell>{row.date}</TableCell>
              <TableCell>{row.name}</TableCell>
              <TableCell>{row.shipTo}</TableCell>
              <TableCell>{row.paymentMethod}</TableCell>
              <TableCell align="right">{row.amount}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
